import { render } from "./PaymentsRequestsView.vue?vue&type=template&id=60ff9cb9"
import script from "./PaymentsRequestsView.vue?vue&type=script&lang=js"
export * from "./PaymentsRequestsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__